import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';

import { Auth, Storage } from '@core/services';
import { Footer } from '@shared/footer/footer';
import { Toaster } from '@shared/services';
import { IUser } from '@core/interfaces';
import { Login as LoginService } from '@modules/login/services/login';

@Component({
  selector: 'app-login',
  imports: [Footer, ReactiveFormsModule],
  templateUrl: './login.html',
  styleUrl: './login.scss'
})
export class Login {
  private router = inject(Router);
  private fb = inject(FormBuilder);
  private loginService = inject(LoginService);
  private toasterService = inject(Toaster);
  private authService = inject(Auth);
  private storageService = inject(Storage);

  passwordVisible = false;

  loginForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(6)]]
  });

  togglePassword() {
    this.passwordVisible = !this.passwordVisible;
  }

  onLogin() {
    if (!this.loginForm.valid) {
      this.toasterService.errorAlert('Please fill in all required fields');
      return;
    }

    const email = this.loginForm.value.email;
    const password = this.loginForm.value.password;
    this.loginService.login(email, password).subscribe({
      next: (response: { data: IUser }) => {
        this.authService.user = response.data;
        this.authService.token = response.data.token;
        this.storageService.setItem('user', response.data);
        this.storageService.setItem('token', response.data.token);
        this.toasterService.successAlert('Login successful');
        this.router.navigate(['/dashboard']);
      },
      error: (error) => {
        this.toasterService.errorAlert(error.error.message);
      }
    });
  }
}
